/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsvoided1Inputs */

const en_ticketsvoided1 = /** @type {(inputs: Ticketsvoided1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket voided`)
};

const de_ticketsvoided1 = /** @type {(inputs: Ticketsvoided1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket ist jetzt ungültig`)
};

/**
* | output |
* | --- |
* | "Ticket voided" |
*
* @param {Ticketsvoided1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsvoided1 = /** @type {((inputs?: Ticketsvoided1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsvoided1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsvoided1(inputs)
	return de_ticketsvoided1(inputs)
});
export { ticketsvoided1 as "ticketsVoided" }